import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { PackageService, STANDARD_PACKAGE_ID } from '../../services/package-service';
import { convertPackagesWeightAndDimensions } from '../../services/unit-services/package-services/packages-unit-conversion-service';
import Global from '../../store/global-selectors';
import { useEnablePackageDropdownGenericFallback } from '../../feature-flags/hooks/use-enable-package-dropdown-generic-fallback';
import { emptyArray } from 'ui-components/default-props/empty';

// we use "packageId" to track packages because packageTypeIds are not unique across carriers
// 'packageTypeId-isCustom(bool)-carrierId'
export const addPackageId = (entityPackages, accountPackages, isPackageDropdownGenericFallbackEnabled = false) => {
  if (!entityPackages || entityPackages.length === 0) {
    return emptyArray;
  }

  if (entityPackages.every((p) => p.packageId)) {
    return entityPackages;
  }

  const singlePackage = entityPackages[0];
  const realPackage = PackageService.findBestGuessPackageByPackageTypeId(singlePackage.packageTypeId, accountPackages);

  return entityPackages.map((p) => {
    const packageId = isPackageDropdownGenericFallbackEnabled
      ? `${p?.packageTypeId ?? STANDARD_PACKAGE_ID}-${realPackage?.isCustom ?? 'false'}-${realPackage?.carrierId || 'null'}`
      : `${p?.packageTypeId || 'null'}-${realPackage?.isCustom ?? 'false'}-${realPackage?.carrierId || 'null'}`;

    return {
      ...p,
      packageId,
      isCustom: realPackage?.isCustom,
    };
  });
};

export const useConfigurePackages = () => {
  const accountPackages = useSelector(Global.selectSellerPackages);
  const sellerDefaultWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const sellerDefaultDimensionsUnit = useSelector(Global.selectSellerDefaultDimensionUnit);
  const isPackageDropdownGenericFallbackEnabled = useEnablePackageDropdownGenericFallback();

  const configurePackages = useCallback(
    (entityPackages) => {
      const packagesWithPackageId = addPackageId(entityPackages, accountPackages, isPackageDropdownGenericFallbackEnabled);
      return convertPackagesWeightAndDimensions(packagesWithPackageId, sellerDefaultWeightUnit, sellerDefaultDimensionsUnit);
    },
    [accountPackages, isPackageDropdownGenericFallbackEnabled, sellerDefaultWeightUnit, sellerDefaultDimensionsUnit],
  );
  return configurePackages;
};
